(() => {
  'use strict';

  const loader = document.getElementById('c_product-review-schema-loader');
  if (!loader) return;
  const productId = loader.dataset.productId;
  const productPath = new URL(loader.dataset.productUrl, window.location.origin).pathname;
  const ownedTargets = new WeakMap();

  function isCurrentProduct(entity) {
    if (!entity || typeof entity !== 'object' || !entity.name) return false;
    const types = [].concat(entity['@type'] || []);
    if (!types.includes('Product') && !types.includes('ProductGroup')) return false;
    if (String(entity.productGroupID || '') === productId) return true;
    return [entity.url, entity['@id']].some((value) => {
      if (typeof value !== 'string') return false;
      try {
        const url = new URL(value, window.location.origin);
        return url.origin === window.location.origin && url.pathname === productPath;
      } catch (_) {
        return false;
      }
    });
  }

  function getEntities(data) {
    if (Array.isArray(data)) return data.flatMap(getEntities);
    if (!data || typeof data !== 'object') return [];
    return [data, ...getEntities(data['@graph'])];
  }

  function readRating(root) {
    const summary = root.querySelector('.LRSDLink');
    if (!summary || !summary.getClientRects().length) return null;
    const style = window.getComputedStyle(summary);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return null;
    const valueText = summary.querySelector('.LRSDValue')?.textContent.trim() || '';
    const countText = summary.querySelector('.LRSDTotalCountValue')?.textContent.trim() || '';
    if (!/^\d+(?:\.\d+)?$/.test(valueText) || !/^\d+(?:,\d{3})*$/.test(countText)) return null;
    const ratingValue = Number(valueText);
    const reviewCount = Number(countText.replace(/,/g, ''));
    if (!Number.isFinite(ratingValue) || ratingValue < 1 || ratingValue > 5) return null;
    if (!Number.isSafeInteger(reviewCount) || reviewCount < 1) return null;
    return { '@type': 'AggregateRating', ratingValue, reviewCount, bestRating: 5, worstRating: 1 };
  }

  function syncRating(root) {
    const rating = readRating(root);
    document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
      let data;
      try {
        data = JSON.parse(script.textContent);
      } catch (_) {
        return;
      }
      const owned = ownedTargets.get(script) || new Set();
      let changed = false;
      getEntities(data).filter(isCurrentProduct).forEach((entity) => {
        const key = entity['@id'] || entity.url || entity.productGroupID;
        // 他のアプリやShopifyが既に出力する集計は上書きしない。
        if (entity.aggregateRating && !owned.has(key)) return;
        if (rating) {
          if (JSON.stringify(entity.aggregateRating) !== JSON.stringify(rating)) {
            entity.aggregateRating = rating;
            changed = true;
          }
          owned.add(key);
        } else if (owned.has(key) && entity.aggregateRating) {
          delete entity.aggregateRating;
          changed = true;
        }
      });
      if (changed) {
        // 価格・在庫・バリエーション等はそのまま残し、集計値だけ補完する。
        script.textContent = JSON.stringify(data).replace(/</g, '\\u003c');
        ownedTargets.set(script, owned);
      }
    });
  }

  function init() {
    const rootSelector = '.c_product-info__leeep-tag';
    const observedRoots = new WeakSet();
    let queued = false;
    let retryTimer;
    const update = () => {
      if (queued) return;
      queued = true;
      window.queueMicrotask(() => {
        queued = false;
        const roots = Array.from(document.querySelectorAll(rootSelector));
        const visibleRoot = roots.find((item) => readRating(item));
        if (visibleRoot) window.clearInterval(retryTimer);
        const root = visibleRoot || roots[0];
        if (root) syncRating(root);
      });
    };
    const bindRoots = () => {
      document.querySelectorAll(rootSelector).forEach((root) => {
        if (observedRoots.has(root)) return;
        observedRoots.add(root);
        const observer = new MutationObserver(update);
        observer.observe(root, {
          childList: true, subtree: true, characterData: true,
          attributes: true, attributeFilter: ['style', 'class', 'hidden']
        });
      });
      update();
    };
    // 商品アコーディオン等による埋め込み要素の差し替えにも追従する。
    const replacementObserver = new MutationObserver((records) => {
      const replaced = records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) =>
        node.nodeType === 1 && (node.matches(rootSelector) || node.querySelector(rootSelector))
      ));
      if (replaced) bindRoots();
    });
    replacementObserver.observe(document.body, { childList: true, subtree: true });
    bindRoots();
    // 外部CSSの読込完了ではDOM変更が起きない場合があるため、初期描画だけ再確認する。
    retryTimer = window.setInterval(update, 500);
    window.setTimeout(() => window.clearInterval(retryTimer), 30000);
    window.addEventListener('load', update, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
